const initialState = {
    activeTimers: [],
    expiredTimers: [],
    loading: false,
    error: null,
  };
  
  const timerReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_TIMERS_SUCCESS":
        return {
          ...state,
          activeTimers: action.payload.activeTimers,
          expiredTimers: action.payload.expiredTimers,
        };
  
      case "FETCH_TIMERS_FAILURE":
        return {
          ...state,
          error: action.payload,
        };
  
      case "CREATE_TIMER_SUCCESS":
        return {
          ...state,
          activeTimers: [...state.activeTimers, action.payload],
        };
  
      case "MARK_TIMERS_AS_READ_SUCCESS":

        console.log(action.payload)
        return {
          ...state,
          expiredTimers: [...state?.expiredTimers?.map((item) => {
            if(item.is_readed || !action.payload.includes(item.id)) return item;
            return {
              ...item,
              is_readed: true
            }
          })],
        };
  
      case "UPDATE_TIMERS": {
        const updatedActiveTimers = [];
        const expiredTimers = [...state.expiredTimers];
      
        state.activeTimers.forEach((timer) => {
          if (timer.timeLeft > 0) {
            updatedActiveTimers.push({ ...timer, timeLeft: timer.timeLeft - 1 });
          } else {
            expiredTimers.push(timer);
          }
        });
      
        return {
          ...state,
          activeTimers: updatedActiveTimers,
          expiredTimers,
        };
      }

      case "MARK_TIMERS_AS_ARRIVED_SUCCESS": {
        console.log("PAYLOAD: ", action.payload, " ExpiredTimers:", state?.expiredTimers);
        return {
          ...state,
          expiredTimers: state?.expiredTimers?.map((item) => {
            if(!action.payload.includes(item.id)) return item;
            return {
              ...item,
              client_has_already_arrived: true
            }
          }),
        }
      }
      case 'LOGOUT': {
        return initialState;
      }
      default:
        return state;
    }
  };
  
  export default timerReducer;
